import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBContainer,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,} from 'mdbreact'; */
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import WarningBox from "../components/WarningBox";

import { toast, ToastContainer } from "mdbreact";
import AddEditOutsourcedItem from "../Administrator/AddEditOutsourcedItem";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
const AddEditPayment = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  let intTotalSales = useSelector((state) => state.sales.value);
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [frm, setValues] = useState({
    code: props.code,
    description: { value: "initialpayment", label: "INITIAL PAYMENT" },
    amount: 0,
    usercode: sessionStorage.getItem("msal.uc"),
    parentcode: props.parentcode,
    deleted: false,
  });

  const [passwordShown, setPasswordShown] = useState(false);

  const [disabledClass, setDisabledClass] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savepayments();
  }

  const [paymentdescriptionoptions, setpaymentdescriptionoptions] = useState(
    []
  );
  const getpaymentsoptions = () => {
    Axios.get(props.apiServer + "/getpaymentsoptions", bearer)
      .then((res) => {
        setpaymentdescriptionoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [modalCustomerQuickAddOption, showCustomerQuickAddOption] =
    useState(false);
  const toggleCustomerQuickAddOption = () => {
    getitemsservicesoptions();
    showCustomerQuickAddOption(!modalCustomerQuickAddOption);
  };
  const [modalCustomerOption, showCustomerOption] = useState(false);
  const toggleCustomerOption = () => {
    getitemsservicesoptions();
    showCustomerOption(!modalCustomerOption);
  };

  const loadpaymentdetails = () => {
    Axios.get(
      props.apiServer + "/loadpaymentdetails?code=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,

            description: {
              value: new String(res.data.description)
                .toString()
                .replace(" ", "")
                .toLowerCase(),
              label: res.data.description,
            },
            amount: res.data.amount,
            usercode: res.data.createdby,
            parentcode: props.parentcode,
            deleted: res.data.deleted,
          });
        } else {
          console.log("No record");
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const savepayments = () => {
    const data = frm;

    Axios.post(props.apiServer + "/savepayments", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          if (props.code === "new") {
            props.toggleModal();
          }
          props.refreshSales();
          props.refreshGrid();
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const deleteitem = () => {
    const data = frm;

    Axios.post(props.apiServer + "/deleteitem", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          props.refreshGrid();

          toast.info(res.data.message, {
            closeButton: false,
          });
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  const [itemsservicesoptions, setitemsservicesoptions] = useState([]);
  const getitemsservicesoptions = () => {
    Axios.get(props.apiServer + "/getitemsservicesoptions", bearer)
      .then((res) => {
        setitemsservicesoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  useMountEffect(getpaymentsoptions);

  useMountEffect(loadpaymentdetails);

  return (
    <React.Fragment>
      <MDBContainer fluid>
        <MDBRow>
          <MDBCol md="12">
            {" "}
            {props.code === "new" ? (
              <></>
            ) : (
              <>
                <h5
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="display-5 dark-grey-text ml-1 pt-3"
                >
                  Edit Recommendation
                </h5>
              </>
            )}
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.code}
                    id="code"
                    label="code"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="8">
                  <label className="grey-text">
                    <small>&nbsp;Payment Description</small>
                  </label>
                  <br />
                  <CreatableSelect
                    isClearable
                    value={frm.description}
                    onChange={handleChange("description")}
                    options={paymentdescriptionoptions}
                    required
                  />

                  <br />
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.amount}
                    id="amount"
                    label="Amount Paid"
                    type="number"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="12">
                  <MDBInput
                    id="deleted"
                    label="Deleted"
                    labelClass="font-weight-bold red-text"
                    type="checkbox"
                    checked={frm.deleted}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="6">
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>{" "}
                  {props.code === "new" ? (
                    <MDBBtn
                      className="cloudy-knoxville-gradient blue-text"
                      onClick={props.toggleModal}
                    >
                      Close
                    </MDBBtn>
                  ) : (
                    ""
                  )}
                </MDBCol>
                <MDBCol md="6"></MDBCol>
              </MDBRow>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <MDBModal
        backdrop={false}
        isOpen={modalCustomerQuickAddOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleCustomerQuickAddOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Add Outsourced Charge
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <AddEditOutsourcedItem
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quickadd={"yes"}
            toggleModal2={toggleCustomerQuickAddOption}
            itemcode={""}
            toggleModal={props.toggleAddEdit}
            refreshGrid={props.refreshGrid}
          />
        </MDBModalBody>
      </MDBModal>
      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      />

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditPayment;
